"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyPlaceProximityAction = exports.VenueEventVisibility = exports.MyPlacesProximityRolloutMode = exports.FeatureFlagKey = exports.VenueGroupingMode = exports.VenueActivityFilter = exports.MapVersion = exports.AdminEventJourneyStepType = exports.EventSource = exports.EngagementEventType = exports.PeekType = exports.WarningCode = exports.VenueSuggestionStatus = exports.VenueOpeningHoursSource = exports.VenueType = exports.SocketEvent = exports.UserDeviceType = exports.SubGender = exports.NonBinarySubGender = exports.ManSubGender = exports.WomanSubGender = exports.Gender = exports.EmailType = exports.LogEntryLevel = exports.NotificationPresetVariant = exports.NotificationPresetVenuePresence = exports.NotificationPresetTriggerCategory = exports.NotificationPresetTrigger = exports.SystemHealthComponentId = exports.SystemHealthStatus = exports.JobType = exports.JobStatus = exports.CustomerStatus = exports.AccountStatus = exports.AccountIdentityConflictReason = exports.SsoRegistrationTelephoneFlow = exports.AppleAuthenticationFlow = exports.GoogleAuthenticationFlow = exports.IdentityProvider = exports.AccountRole = exports.AccountKind = exports.ScheduledBlastStatus = exports.MessageRole = exports.AccountAuthenticationType = exports.NotificationDeepLinkTarget = exports.NotificationType = exports.AccountLockType = exports.CheckoutType = exports.ModelName = exports.Environment = void 0;
exports.ContentReportStatus = exports.ContentReportTargetType = exports.ACTIVE_REFUND_REQUEST_STATUSES = exports.RefundRequestStatus = exports.ACTIVE_TICKET_STATUSES = exports.TicketStatus = exports.PhotoVerificationContext = exports.AdminPermission = exports.VenueVisitPlanTimeSlot = exports.VenueAutoCheckInPushAction = exports.VenueAutoCheckInOutcome = exports.NotificationTriggerDiagnosisResult = exports.NotificationLogSource = exports.NotificationLogChannel = exports.NotificationLogStatus = exports.AuditLogProducer = exports.AdminUserBreadcrumbActivityType = exports.ModerationContentType = exports.AuditLogEventType = exports.VenueAggregateType = exports.VenueActivityType = exports.MapFilterState = exports.FootprintsHistoryWindow = void 0;
var Environment;
(function (Environment) {
  Environment["Local"] = "local";
  Environment["Production"] = "production";
  Environment["Development"] = "development";
})(Environment || (exports.Environment = Environment = {}));
var ModelName;
(function (ModelName) {
  ModelName["Otp"] = "Otp";
  ModelName["User"] = "User";
  ModelName["Account"] = "Account";
  ModelName["Venue"] = "Venue";
  ModelName["VenueAlert"] = "VenueAlert";
  ModelName["VenueBreadcrumb"] = "VenueBreadcrumb";
  ModelName["VenueBreadcrumbReply"] = "VenueBreadcrumbReply";
  ModelName["Comment"] = "Comment";
  ModelName["Sticker"] = "Sticker";
})(ModelName || (exports.ModelName = ModelName = {}));
var CheckoutType;
(function (CheckoutType) {
  CheckoutType["AwayFromVenue"] = "AwayFromVenue";
  CheckoutType["Inactive"] = "Inactive";
  CheckoutType["Explicit"] = "Explicit";
  CheckoutType["Unknown"] = "Unknown";
  CheckoutType["System"] = "System";
  CheckoutType["VenueClosed"] = "VenueClosed";
  /** Client-confirmed OS geofence exit (arm-grace + live re-check already done on-device). */
  CheckoutType["GeofenceExit"] = "GeofenceExit";
})(CheckoutType || (exports.CheckoutType = CheckoutType = {}));
var AccountLockType;
(function (AccountLockType) {
  AccountLockType["AntiSpoofing"] = "AntiSpoofing";
  AccountLockType["Admin"] = "Admin";
})(AccountLockType || (exports.AccountLockType = AccountLockType = {}));
var NotificationType;
(function (NotificationType) {
  NotificationType["Otp"] = "Otp";
  NotificationType["CheckedIn"] = "CheckedIn";
  NotificationType["CheckedOut"] = "CheckedOut";
  NotificationType["MessageReceived"] = "MessageReceived";
  NotificationType["LikeReceived"] = "LikeReceived";
  NotificationType["AccountLocked"] = "AccountLocked";
  NotificationType["AccountUnlocked"] = "AccountUnlocked";
  NotificationType["NewUserCheckedInToVenue"] = "NewUserCheckedInToVenue";
  NotificationType["BackgroundedAppPing"] = "BackgroundedAppPing";
  NotificationType["AutoCheckoutPending"] = "AutoCheckoutPending";
  NotificationType["VenueAlert"] = "VenueAlert";
  NotificationType["Blast"] = "Blast";
  NotificationType["ConversationFollowUp"] = "ConversationFollowUp";
  NotificationType["VenueBreadcrumbLiked"] = "VenueBreadcrumbLiked";
  NotificationType["VenueBreadcrumbReplyReceived"] = "VenueBreadcrumbReplyReceived";
  NotificationType["VenueMomentLiked"] = "VenueMomentLiked";
  NotificationType["ModerationWarning"] = "ModerationWarning";
  NotificationType["VenueClosingSoon"] = "VenueClosingSoon";
  NotificationType["VenueClosed"] = "VenueClosed";
  NotificationType["OnboardingIncomplete"] = "OnboardingIncomplete";
  NotificationType["OnboardedMapNotOpened"] = "OnboardedMapNotOpened";
  NotificationType["MapOpenedNoRsvp"] = "MapOpenedNoRsvp";
  NotificationType["MyPlaces"] = "MyPlaces";
  NotificationType["FeedbackReplyReceived"] = "FeedbackReplyReceived";
  /** User is physically near one of their pinned My Places; suggests (or performs) check-in. */
  NotificationType["MyPlaceNearby"] = "MyPlaceNearby";
  /** An auto check-in plan's time slot is underway but the user hasn't checked in at that venue yet. */
  NotificationType["AutoCheckInReminder"] = "AutoCheckInReminder";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
/** Mobile navigation hint included in push `data.deepLinkTarget`. */
var NotificationDeepLinkTarget;
(function (NotificationDeepLinkTarget) {
  NotificationDeepLinkTarget["None"] = "none";
  NotificationDeepLinkTarget["AuthResume"] = "authResume";
  NotificationDeepLinkTarget["Map"] = "map";
  NotificationDeepLinkTarget["MapVenueRsvp"] = "mapVenueRsvp";
  NotificationDeepLinkTarget["MapLiveSignal"] = "mapLiveSignal";
  NotificationDeepLinkTarget["VenuePeek"] = "venuePeek";
  NotificationDeepLinkTarget["EventsTab"] = "eventsTab";
  NotificationDeepLinkTarget["UpcomingEvent"] = "upcomingEvent";
  NotificationDeepLinkTarget["Venue"] = "venue";
  NotificationDeepLinkTarget["User"] = "user";
  NotificationDeepLinkTarget["Conversation"] = "conversation";
  NotificationDeepLinkTarget["Breadcrumb"] = "breadcrumb";
  NotificationDeepLinkTarget["BreadcrumbReply"] = "breadcrumbReply";
  NotificationDeepLinkTarget["VenueBreadcrumbComposer"] = "venueBreadcrumbComposer";
  NotificationDeepLinkTarget["VenueBreadcrumbThread"] = "venueBreadcrumbThread";
  NotificationDeepLinkTarget["Account"] = "account";
  NotificationDeepLinkTarget["FeedbackTopic"] = "feedbackTopic";
})(NotificationDeepLinkTarget || (exports.NotificationDeepLinkTarget = NotificationDeepLinkTarget = {}));
var AccountAuthenticationType;
(function (AccountAuthenticationType) {
  AccountAuthenticationType["Email"] = "Email";
  AccountAuthenticationType["Telephone"] = "Telephone";
  AccountAuthenticationType["Sso"] = "SSO";
})(AccountAuthenticationType || (exports.AccountAuthenticationType = AccountAuthenticationType = {}));
var MessageRole;
(function (MessageRole) {
  MessageRole["Sender"] = "Sender";
  MessageRole["Receiver"] = "Receiver";
})(MessageRole || (exports.MessageRole = MessageRole = {}));
var ScheduledBlastStatus;
(function (ScheduledBlastStatus) {
  ScheduledBlastStatus["Pending"] = "Pending";
  ScheduledBlastStatus["Sent"] = "Sent";
  ScheduledBlastStatus["Cancelled"] = "Cancelled";
  ScheduledBlastStatus["Expired"] = "Expired";
})(ScheduledBlastStatus || (exports.ScheduledBlastStatus = ScheduledBlastStatus = {}));
/** Account portal / identity type stored on `account.kind`. */
var AccountKind;
(function (AccountKind) {
  AccountKind["Admin"] = "Admin";
  AccountKind["User"] = "User";
  AccountKind["Customer"] = "Customer";
})(AccountKind || (exports.AccountRole = exports.AccountKind = AccountKind = {}));
/** Linked sign-in methods on an account (an account may have several at once). */
var IdentityProvider;
(function (IdentityProvider) {
  IdentityProvider["Google"] = "Google";
  IdentityProvider["Apple"] = "Apple";
  IdentityProvider["Telephone"] = "Telephone";
})(IdentityProvider || (exports.IdentityProvider = IdentityProvider = {}));
var GoogleAuthenticationFlow;
(function (GoogleAuthenticationFlow) {
  GoogleAuthenticationFlow["Login"] = "Login";
  GoogleAuthenticationFlow["Registration"] = "Registration";
})(GoogleAuthenticationFlow || (exports.GoogleAuthenticationFlow = GoogleAuthenticationFlow = {}));
var AppleAuthenticationFlow;
(function (AppleAuthenticationFlow) {
  AppleAuthenticationFlow["Login"] = "Login";
  AppleAuthenticationFlow["Registration"] = "Registration";
})(AppleAuthenticationFlow || (exports.AppleAuthenticationFlow = AppleAuthenticationFlow = {}));
/** Outcome of optional telephone step during Google/Apple registration. */
var SsoRegistrationTelephoneFlow;
(function (SsoRegistrationTelephoneFlow) {
  /** OTP sent to the pending SSO registration account — normal happy path. */
  SsoRegistrationTelephoneFlow["OtpSent"] = "OtpSent";
  /** Telephone successfully linked to the pending SSO registration account. */
  SsoRegistrationTelephoneFlow["Verified"] = "Verified";
  /**
   * Telephone (or email) already belongs to another active account.
   * Client must complete conflict resolve with conflictToken instead of verify.
   */
  SsoRegistrationTelephoneFlow["AccountConflict"] = "AccountConflict";
})(SsoRegistrationTelephoneFlow || (exports.SsoRegistrationTelephoneFlow = SsoRegistrationTelephoneFlow = {}));
var AccountIdentityConflictReason;
(function (AccountIdentityConflictReason) {
  AccountIdentityConflictReason["TelephoneTaken"] = "TelephoneTaken";
  AccountIdentityConflictReason["EmailTaken"] = "EmailTaken";
})(AccountIdentityConflictReason || (exports.AccountIdentityConflictReason = AccountIdentityConflictReason = {}));
var AccountStatus;
(function (AccountStatus) {
  AccountStatus["Active"] = "Active";
  AccountStatus["Deleted"] = "Deleted";
  AccountStatus["Pending"] = "Pending";
  AccountStatus["Inactive"] = "Inactive";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var CustomerStatus;
(function (CustomerStatus) {
  CustomerStatus["FreeTier"] = "FreeTier";
  CustomerStatus["Paying"] = "Paying";
  CustomerStatus["Premium"] = "Premium";
  CustomerStatus["Cancelled"] = "Cancelled";
})(CustomerStatus || (exports.CustomerStatus = CustomerStatus = {}));
var JobStatus;
(function (JobStatus) {
  JobStatus["Ready"] = "Ready";
  JobStatus["Running"] = "Running";
  JobStatus["Paused"] = "Paused";
  JobStatus["TimedOut"] = "TimedOut";
  JobStatus["Disabled"] = "Disabled";
  JobStatus["Overdue"] = "Overdue";
  JobStatus["Failed"] = "Failed";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
var JobType;
(function (JobType) {
  JobType["RunDiagnostics"] = "RunDiagnostics";
  JobType["DeliverEmail"] = "DeliverEmail";
  JobType["AutoCheckoutUsers"] = "AutoCheckoutUsers";
  JobType["DeactivateIdleAccounts"] = "DeactivateIdleAccounts";
  JobType["SendVenueAlerts"] = "SendVenueAlerts";
  JobType["UpdateUserBadgeCounts"] = "UpdateUserBadgeCounts";
  JobType["AutoUnlockAccounts"] = "AutoUnlockAccounts";
  JobType["SendScheduledNotificationPresets"] = "SendScheduledNotificationPresets";
  JobType["EvaluateMyPlacesNotifications"] = "EvaluateMyPlacesNotifications";
  JobType["SyncAppStoreReviews"] = "SyncAppStoreReviews";
})(JobType || (exports.JobType = JobType = {}));
var SystemHealthStatus;
(function (SystemHealthStatus) {
  SystemHealthStatus["Healthy"] = "healthy";
  SystemHealthStatus["Degraded"] = "degraded";
  SystemHealthStatus["Unhealthy"] = "unhealthy";
  SystemHealthStatus["NotConfigured"] = "not_configured";
})(SystemHealthStatus || (exports.SystemHealthStatus = SystemHealthStatus = {}));
var SystemHealthComponentId;
(function (SystemHealthComponentId) {
  SystemHealthComponentId["Backend"] = "backend";
  SystemHealthComponentId["Database"] = "database";
  SystemHealthComponentId["S3"] = "s3";
  SystemHealthComponentId["LocalStorage"] = "local_storage";
  SystemHealthComponentId["SendGrid"] = "sendgrid";
  SystemHealthComponentId["Twilio"] = "twilio";
  SystemHealthComponentId["OneSignal"] = "onesignal";
  SystemHealthComponentId["GoogleVision"] = "google_vision";
  SystemHealthComponentId["GoogleMaps"] = "google_maps";
  SystemHealthComponentId["WebSocket"] = "websocket";
  SystemHealthComponentId["ScheduledJobs"] = "scheduled_jobs";
  SystemHealthComponentId["Square"] = "square";
})(SystemHealthComponentId || (exports.SystemHealthComponentId = SystemHealthComponentId = {}));
/** When a preset should be evaluated and sent. */
var NotificationPresetTrigger;
(function (NotificationPresetTrigger) {
  NotificationPresetTrigger["IncompleteOnboarding"] = "IncompleteOnboarding";
  NotificationPresetTrigger["OnboardedMapNotOpened"] = "OnboardedMapNotOpened";
  NotificationPresetTrigger["MapOpenedNoRsvp"] = "MapOpenedNoRsvp";
  NotificationPresetTrigger["HabitLoopRsvpOrVisitPlanNoCheckin"] = "HabitLoopRsvpOrVisitPlanNoCheckin";
  NotificationPresetTrigger["HabitLoopCheckedInNoBreadcrumb"] = "HabitLoopCheckedInNoBreadcrumb";
  NotificationPresetTrigger["HabitLoopActiveUserIdleLiveSignal"] = "HabitLoopActiveUserIdleLiveSignal";
  NotificationPresetTrigger["ResurrectionLapsedSend1"] = "ResurrectionLapsedSend1";
  NotificationPresetTrigger["ResurrectionLapsedSend2"] = "ResurrectionLapsedSend2";
  NotificationPresetTrigger["ResurrectionLapsedSend3"] = "ResurrectionLapsedSend3";
  NotificationPresetTrigger["LikeReceived"] = "LikeReceived";
  NotificationPresetTrigger["BreadcrumbLiked"] = "BreadcrumbLiked";
  NotificationPresetTrigger["BreadcrumbReplyReceived"] = "BreadcrumbReplyReceived";
  NotificationPresetTrigger["MomentLiked"] = "MomentLiked";
  NotificationPresetTrigger["MessageReceived"] = "MessageReceived";
  NotificationPresetTrigger["AdminWarnReceived"] = "AdminWarnReceived";
  NotificationPresetTrigger["VenueCheckedIn"] = "VenueCheckedIn";
  NotificationPresetTrigger["VenueCheckedOut"] = "VenueCheckedOut";
  NotificationPresetTrigger["NewUserCheckedInToVenue"] = "NewUserCheckedInToVenue";
  NotificationPresetTrigger["AntiSpoofingLockReceived"] = "AntiSpoofingLockReceived";
  NotificationPresetTrigger["AdminLockReceived"] = "AdminLockReceived";
  NotificationPresetTrigger["AdminUnlockReceived"] = "AdminUnlockReceived";
  NotificationPresetTrigger["AutoUnlockReceived"] = "AutoUnlockReceived";
  NotificationPresetTrigger["ConversationFollowUp"] = "ConversationFollowUp";
  NotificationPresetTrigger["MyPlacesActivity"] = "MyPlacesActivity";
  NotificationPresetTrigger["FeedbackReplyReceived"] = "FeedbackReplyReceived";
})(NotificationPresetTrigger || (exports.NotificationPresetTrigger = NotificationPresetTrigger = {}));
/** High-level grouping for notification preset triggers in the admin UI. */
var NotificationPresetTriggerCategory;
(function (NotificationPresetTriggerCategory) {
  NotificationPresetTriggerCategory["ActivationGates"] = "ActivationGates";
  NotificationPresetTriggerCategory["HabitLoop"] = "HabitLoop";
  NotificationPresetTriggerCategory["Resurrection"] = "Resurrection";
  NotificationPresetTriggerCategory["SocialEvents"] = "SocialEvents";
  NotificationPresetTriggerCategory["Venue"] = "Venue";
  NotificationPresetTriggerCategory["AccountModeration"] = "AccountModeration";
  NotificationPresetTriggerCategory["ConversationFollowUp"] = "ConversationFollowUp";
  NotificationPresetTriggerCategory["MyPlaces"] = "MyPlaces";
  NotificationPresetTriggerCategory["Support"] = "Support";
})(NotificationPresetTriggerCategory || (exports.NotificationPresetTriggerCategory = NotificationPresetTriggerCategory = {}));
/** Required recipient check-in state relative to the venue referenced by a notification. */
var NotificationPresetVenuePresence;
(function (NotificationPresetVenuePresence) {
  NotificationPresetVenuePresence["Any"] = "Any";
  NotificationPresetVenuePresence["AtVenue"] = "AtVenue";
  NotificationPresetVenuePresence["NotAtVenue"] = "NotAtVenue";
})(NotificationPresetVenuePresence || (exports.NotificationPresetVenuePresence = NotificationPresetVenuePresence = {}));
/** Message variant that controls which template variables are resolved. */
var NotificationPresetVariant;
(function (NotificationPresetVariant) {
  NotificationPresetVariant["Default"] = "Default";
  NotificationPresetVariant["LiveCheckins"] = "LiveCheckins";
  NotificationPresetVariant["LiveViews"] = "LiveViews";
  NotificationPresetVariant["Breadcrumbs"] = "Breadcrumbs";
  NotificationPresetVariant["VisitPlans"] = "VisitPlans";
  NotificationPresetVariant["Events"] = "Events";
  NotificationPresetVariant["PeopleHere"] = "PeopleHere";
  NotificationPresetVariant["MatchingUsersHere"] = "MatchingUsersHere";
  NotificationPresetVariant["MutualConnectionsHere"] = "MutualConnectionsHere";
  NotificationPresetVariant["RecentViewsHere"] = "RecentViewsHere";
  NotificationPresetVariant["MatchedNoChat"] = "MatchedNoChat";
  NotificationPresetVariant["ResumeChatAfterEvent"] = "ResumeChatAfterEvent";
})(NotificationPresetVariant || (exports.NotificationPresetVariant = NotificationPresetVariant = {}));
var LogEntryLevel;
(function (LogEntryLevel) {
  LogEntryLevel["Debug"] = "Debug";
  LogEntryLevel["Info"] = "Info";
  LogEntryLevel["Warning"] = "Warning";
  LogEntryLevel["Error"] = "Error";
})(LogEntryLevel || (exports.LogEntryLevel = LogEntryLevel = {}));
var EmailType;
(function (EmailType) {
  EmailType["UnhandledException"] = "UnhandledException";
  EmailType["VerifyEmail"] = "VerifyEmail";
  EmailType["RequestPasswordReset"] = "RequestPasswordReset";
  EmailType["PasswordUpdateConfirmation"] = "PasswordUpdateConfirmation";
  EmailType["Diagnostics"] = "Diagnostics";
  EmailType["UserBlockedUser"] = "UserBlockedUser";
})(EmailType || (exports.EmailType = EmailType = {}));
var Gender;
(function (Gender) {
  Gender["Male"] = "Male";
  Gender["Female"] = "Female";
  Gender["Trans"] = "Trans";
  Gender["NonBinary"] = "Non-Binary";
  Gender["Unknown"] = "Unknown";
})(Gender || (exports.Gender = Gender = {}));
/** Sub-genders under Gender.Female ("Woman"). */
var WomanSubGender;
(function (WomanSubGender) {
  WomanSubGender["CisWoman"] = "Cis woman";
  WomanSubGender["WomanAndNonbinary"] = "Woman & Nonbinary";
  WomanSubGender["TransWoman"] = "Trans woman";
  WomanSubGender["Transfeminine"] = "Transfeminine";
  WomanSubGender["IntersexWoman"] = "Intersex woman";
})(WomanSubGender || (exports.WomanSubGender = WomanSubGender = {}));
/** Sub-genders under Gender.Male ("Man"). */
var ManSubGender;
(function (ManSubGender) {
  ManSubGender["CisMan"] = "Cis man";
  ManSubGender["ManAndNonbinary"] = "Man & Nonbinary";
  ManSubGender["TransMan"] = "Trans man";
  ManSubGender["Transmasculine"] = "Transmasculine";
  ManSubGender["IntersexMan"] = "Intersex man";
})(ManSubGender || (exports.ManSubGender = ManSubGender = {}));
/** Sub-genders under Gender.NonBinary ("Nonbinary"). */
var NonBinarySubGender;
(function (NonBinarySubGender) {
  NonBinarySubGender["Agender"] = "Agender";
  NonBinarySubGender["Bigender"] = "Bigender";
  NonBinarySubGender["Genderfluid"] = "Genderfluid";
  NonBinarySubGender["Intersex"] = "Intersex";
  NonBinarySubGender["Genderqueer"] = "Genderqueer";
  NonBinarySubGender["GenderNonconforming"] = "Gender nonconforming";
  NonBinarySubGender["Pangender"] = "Pangender";
  NonBinarySubGender["Polygender"] = "Polygender";
  NonBinarySubGender["Transgender"] = "Transgender";
  NonBinarySubGender["TwoSpirit"] = "Two-spirit";
})(NonBinarySubGender || (exports.NonBinarySubGender = NonBinarySubGender = {}));
/** Flat enum of all sub-genders (for storage / API payloads). */
var SubGender;
(function (SubGender) {
  SubGender["CisWoman"] = "Cis woman";
  SubGender["WomanAndNonbinary"] = "Woman & Nonbinary";
  SubGender["TransWoman"] = "Trans woman";
  SubGender["Transfeminine"] = "Transfeminine";
  SubGender["IntersexWoman"] = "Intersex woman";
  SubGender["CisMan"] = "Cis man";
  SubGender["ManAndNonbinary"] = "Man & Nonbinary";
  SubGender["TransMan"] = "Trans man";
  SubGender["Transmasculine"] = "Transmasculine";
  SubGender["IntersexMan"] = "Intersex man";
  SubGender["Agender"] = "Agender";
  SubGender["Bigender"] = "Bigender";
  SubGender["Genderfluid"] = "Genderfluid";
  SubGender["Intersex"] = "Intersex";
  SubGender["Genderqueer"] = "Genderqueer";
  SubGender["GenderNonconforming"] = "Gender nonconforming";
  SubGender["Pangender"] = "Pangender";
  SubGender["Polygender"] = "Polygender";
  SubGender["Transgender"] = "Transgender";
  SubGender["TwoSpirit"] = "Two-spirit";
})(SubGender || (exports.SubGender = SubGender = {}));
var UserDeviceType;
(function (UserDeviceType) {
  UserDeviceType["iOS"] = "iOS";
  UserDeviceType["Android"] = "Android";
})(UserDeviceType || (exports.UserDeviceType = UserDeviceType = {}));
var SocketEvent;
(function (SocketEvent) {
  SocketEvent["messageReceived"] = "messageReceived";
  SocketEvent["messageSent"] = "messageSent";
  SocketEvent["userCheckedInToVenue"] = "userCheckedInToVenue";
  SocketEvent["userCheckedOutOfVenue"] = "userCheckedOutOfVenue";
  SocketEvent["blockedByUser"] = "blockedByUser";
  SocketEvent["deleteConversation"] = "deleteConversation";
  SocketEvent["unblockedByUser"] = "unblockedByUser";
  SocketEvent["locationUpdated"] = "locationUpdated";
  SocketEvent["likedByUser"] = "likedByUser";
  SocketEvent["unlikedByUser"] = "unlikedByUser";
  SocketEvent["wavedToByUser"] = "wavedToByUser";
  SocketEvent["vibeEmojiUpdateInVenue"] = "vibeEmojiUpdateInVenue";
  SocketEvent["intentionUpdateInVenue"] = "intentionUpdateInVenue";
  SocketEvent["autoCheckedOutOfVenue"] = "autoCheckedOutOfVenue";
  SocketEvent["createBreadcrumb"] = "createBreadcrumb";
  SocketEvent["updateBreadcrumb"] = "updateBreadcrumb";
  SocketEvent["deleteBreadcrumb"] = "deleteBreadcrumb";
  SocketEvent["addBreadcrumbReaction"] = "addBreadcrumbReaction";
  SocketEvent["removeBreadcrumbReaction"] = "removeBreadcrumbReaction";
  SocketEvent["createBreadcrumbReply"] = "createBreadcrumbReply";
  SocketEvent["createSticker"] = "createSticker";
  SocketEvent["deleteSticker"] = "deleteSticker";
  SocketEvent["featureFlagUpdated"] = "featureFlagUpdated";
  SocketEvent["venueClosingSoon"] = "venueClosingSoon";
  SocketEvent["feedbackReplyReceived"] = "feedbackReplyReceived";
  SocketEvent["feedbackTopicClosed"] = "feedbackTopicClosed";
})(SocketEvent || (exports.SocketEvent = SocketEvent = {}));
var VenueType;
(function (VenueType) {
  VenueType["Bar"] = "Bar";
  VenueType["Restaurant"] = "Restaurant";
  VenueType["Nightclub"] = "Nightclub";
  VenueType["Cafe"] = "Cafe";
  VenueType["Other"] = "Other";
  VenueType["Gym"] = "Gym";
  VenueType["Bookstore"] = "Bookstore";
  VenueType["Museum"] = "Museum";
  VenueType["Park"] = "Park";
  VenueType["Outside"] = "Outside";
  VenueType["Shop"] = "Shop";
  VenueType["Party"] = "Party";
  VenueType["Movies"] = "Movies";
  VenueType["Concert"] = "Concert";
  VenueType["Coffee"] = "Coffee";
  VenueType["Attraction"] = "Attraction";
})(VenueType || (exports.VenueType = VenueType = {}));
var VenueOpeningHoursSource;
(function (VenueOpeningHoursSource) {
  VenueOpeningHoursSource["Custom"] = "custom";
  VenueOpeningHoursSource["Google"] = "google";
})(VenueOpeningHoursSource || (exports.VenueOpeningHoursSource = VenueOpeningHoursSource = {}));
var VenueSuggestionStatus;
(function (VenueSuggestionStatus) {
  VenueSuggestionStatus["Pending"] = "Pending";
  VenueSuggestionStatus["Approved"] = "Approved";
  VenueSuggestionStatus["Rejected"] = "Rejected";
})(VenueSuggestionStatus || (exports.VenueSuggestionStatus = VenueSuggestionStatus = {}));
var WarningCode;
(function (WarningCode) {
  WarningCode["AutoCheckedInWithinHour"] = "AutoCheckedInWithinHour";
})(WarningCode || (exports.WarningCode = WarningCode = {}));
var PeekType;
(function (PeekType) {
  PeekType["Spotlight"] = "Spotlight";
  PeekType["Map"] = "Map";
  PeekType["List"] = "List";
  PeekType["Directions"] = "Directions";
  PeekType["Search"] = "Search";
  /** Peeked from the map's Footprints (own visit history) list. */
  PeekType["Footprints"] = "Footprints";
})(PeekType || (exports.PeekType = PeekType = {}));
/** Client-side engagement events logged via POST /user/engagement-events (one row per occurrence). */
var EngagementEventType;
(function (EngagementEventType) {
  /** Partnered hotspot modal opened automatically on app launch. */
  EngagementEventType["HotspotModalShown"] = "hotspot_modal_shown";
  /** User tapped the collapsed partnered hotspot card to open the modal. */
  EngagementEventType["HotspotCardTapped"] = "hotspot_card_tapped";
  /** User tapped the CTA inside the partnered hotspot modal (opens the event). */
  EngagementEventType["HotspotCtaTapped"] = "hotspot_cta_tapped";
  /** User tapped "Get a Ticket" on the event detail screen. */
  EngagementEventType["GetTicketsTapped"] = "get_tickets_tapped";
})(EngagementEventType || (exports.EngagementEventType = EngagementEventType = {}));
/** Where the user opened the event from — attributed to RSVPs, ticket purchases and "Get tickets" taps. */
var EventSource;
(function (EventSource) {
  EventSource["Hotspot"] = "hotspot";
  EventSource["EventList"] = "event_list";
  EventSource["Spotlight"] = "spotlight";
  EventSource["Push"] = "push";
  /** Venue card, shared link, or anything else. */
  EventSource["Other"] = "other";
})(EventSource || (exports.EventSource = EventSource = {}));
/** A step on a user's path to an event in the admin journey view. */
var AdminEventJourneyStepType;
(function (AdminEventJourneyStepType) {
  AdminEventJourneyStepType["HotspotModalShown"] = "hotspot_modal_shown";
  AdminEventJourneyStepType["HotspotCardTapped"] = "hotspot_card_tapped";
  AdminEventJourneyStepType["HotspotCtaTapped"] = "hotspot_cta_tapped";
  AdminEventJourneyStepType["GetTicketsTapped"] = "get_tickets_tapped";
  AdminEventJourneyStepType["Rsvp"] = "rsvp";
  AdminEventJourneyStepType["TicketPurchase"] = "ticket_purchase";
})(AdminEventJourneyStepType || (exports.AdminEventJourneyStepType = AdminEventJourneyStepType = {}));
var MapVersion;
(function (MapVersion) {
  MapVersion["Legacy"] = "Legacy";
  MapVersion["New"] = "New";
})(MapVersion || (exports.MapVersion = MapVersion = {}));
/** `venues/nearby` and `venues/bounded` `activity` query param. */
var VenueActivityFilter;
(function (VenueActivityFilter) {
  /** Only venues meeting the "active" threshold — see hasAnyMapActivitySignal. */
  VenueActivityFilter["Recent"] = "recent";
})(VenueActivityFilter || (exports.VenueActivityFilter = VenueActivityFilter = {}));
/** How venue markers are presented on the mobile map (clustered vs one pin per venue). */
var VenueGroupingMode;
(function (VenueGroupingMode) {
  VenueGroupingMode["Ungrouped"] = "Ungrouped";
  VenueGroupingMode["Grouped"] = "Grouped";
})(VenueGroupingMode || (exports.VenueGroupingMode = VenueGroupingMode = {}));
var FeatureFlagKey;
(function (FeatureFlagKey) {
  FeatureFlagKey["MapVersion"] = "mapVersion";
  /** Exposed on `/me` as `venueGroupingMode`. */
  FeatureFlagKey["VenueGroupingMode"] = "venueGroupingMode";
  /**
   * Semver (X.Y.Z) set in admin. Exposed as `/me` `appVersion` and as `publishedAppVersion` on user payloads
   * (when valid); otherwise `publishedAppVersion` falls back to `PUBLISHED_APP_VERSION` env.
   */
  FeatureFlagKey["MinimumAppVersion"] = "minimumAppVersion";
  /** Exposed on `/me` as `mapFilters`. */
  FeatureFlagKey["MapFilters"] = "mapFilters";
  /** Admin-tunable hotspot detection parameters (K, range, min gap, cache TTL). */
  FeatureFlagKey["HotspotConfig"] = "hotspotConfig";
  /** Display name shown to users as the sender of support/feedback replies and related notifications. */
  FeatureFlagKey["SupportName"] = "supportName";
  /** Rollout + tuning for "near a My Place" proximity notifications. */
  FeatureFlagKey["MyPlacesProximity"] = "myPlacesProximity";
  /** Stickers limits and lifetimes (moment hours, per-venue limits, note days). Edited on admin Stickers → Settings. */
  FeatureFlagKey["StickerSettings"] = "stickerSettings";
  /** Per-VenueType display label + emoji for GET user/venues/types (map category filter chips). */
  FeatureFlagKey["VenueTypeLabels"] = "venueTypeLabels";
  /** New-map sidebar filters (icon, label, color, state, order). Exposed on `/me` as `mapActions`. */
  FeatureFlagKey["MapActions"] = "mapActions";
  /** Admin-configured first admin reply auto-posted on a newly created venue-suggestion feedback topic. */
  FeatureFlagKey["VenueSuggestionAutoReplyMessage"] = "venueSuggestionAutoReplyMessage";
  /** Whether the venue-suggestion auto-reply (above) is posted at all. Defaults to true. */
  FeatureFlagKey["VenueSuggestionAutoReplyEnabled"] = "venueSuggestionAutoReplyEnabled";
  /** Admin-configured first admin reply auto-posted on a newly created *general* (non venue-suggestion) feedback topic. */
  FeatureFlagKey["FeedbackAutoReplyMessage"] = "feedbackAutoReplyMessage";
  /** Whether the general-feedback auto-reply (above) is posted at all. Defaults to false. */
  FeatureFlagKey["FeedbackAutoReplyEnabled"] = "feedbackAutoReplyEnabled";
  /**
   * Kill switches for features under test (see `AppFeature`). Boolean; exposed on `/me` as `features`.
   * Off means off for everyone — the app hides the feature and the backend stops serving it.
   */
  FeatureFlagKey["MapUiEnabled"] = "mapUiEnabled";
  FeatureFlagKey["PaymentsEnabled"] = "paymentsEnabled";
  FeatureFlagKey["StickersEnabled"] = "stickersEnabled";
  FeatureFlagKey["EventbriteEnabled"] = "eventbriteEnabled";
  FeatureFlagKey["EventbriteTicketsEnabled"] = "eventbriteTicketsEnabled";
  FeatureFlagKey["AutoCheckInsEnabled"] = "autoCheckInsEnabled";
  FeatureFlagKey["HotspotsEnabled"] = "hotspotsEnabled";
  FeatureFlagKey["GoogleAuthEnabled"] = "googleAuthEnabled";
  FeatureFlagKey["PhotoVerificationEnabled"] = "photoVerificationEnabled";
  FeatureFlagKey["CheckInButtonEnabled"] = "checkInButtonEnabled";
  FeatureFlagKey["ConnectedAccountsEnabled"] = "connectedAccountsEnabled";
  FeatureFlagKey["CalendarSyncEnabled"] = "calendarSyncEnabled";
  FeatureFlagKey["MyTicketsEnabled"] = "myTicketsEnabled";
  FeatureFlagKey["VibrationsEnabled"] = "vibrationsEnabled";
  FeatureFlagKey["MyPlansTabEnabled"] = "myPlansTabEnabled";
  FeatureFlagKey["ColoredListButtonsEnabled"] = "coloredListButtonsEnabled";
})(FeatureFlagKey || (exports.FeatureFlagKey = FeatureFlagKey = {}));
/** Who the "near a My Place" proximity feature is currently live for. */
var MyPlacesProximityRolloutMode;
(function (MyPlacesProximityRolloutMode) {
  MyPlacesProximityRolloutMode["Disabled"] = "disabled";
  MyPlacesProximityRolloutMode["InternalOnly"] = "internal_only";
  MyPlacesProximityRolloutMode["All"] = "all";
})(MyPlacesProximityRolloutMode || (exports.MyPlacesProximityRolloutMode = MyPlacesProximityRolloutMode = {}));
/** Who can see a venue event on mobile. */
var VenueEventVisibility;
(function (VenueEventVisibility) {
  /** Visible to every user. */
  VenueEventVisibility["Public"] = "public";
  /** Visible only to internal users (`User.isInternal`). */
  VenueEventVisibility["InternalOnly"] = "internal_only";
})(VenueEventVisibility || (exports.VenueEventVisibility = VenueEventVisibility = {}));
/** Per-user choice of what happens when they're near one of their My Places. */
var MyPlaceProximityAction;
(function (MyPlaceProximityAction) {
  /** Feature is off for this user; no detection, no notification. */
  MyPlaceProximityAction["Off"] = "off";
  /** Send a push suggesting check-in (single venue or a list, if several are nearby). */
  MyPlaceProximityAction["NotifyAndSuggest"] = "notify_and_suggest";
  /** Check the user in automatically, no prompt. */
  MyPlaceProximityAction["AutoCheckIn"] = "auto_check_in";
})(MyPlaceProximityAction || (exports.MyPlaceProximityAction = MyPlaceProximityAction = {}));
/**
 * Per-user choice of how far back their own check-in history is visible to
 * them in the Footprints list (and the map's "has visited" flag) — a
 * display window only. The backend always retains full history; this never
 * deletes anything, it only changes what the user is shown.
 */
var FootprintsHistoryWindow;
(function (FootprintsHistoryWindow) {
  /** No time cutoff — every visit since the user's visibility floor (if any). */
  FootprintsHistoryWindow["All"] = "All";
  FootprintsHistoryWindow["OneWeek"] = "OneWeek";
  FootprintsHistoryWindow["OneMonth"] = "OneMonth";
  FootprintsHistoryWindow["ThreeMonths"] = "ThreeMonths";
})(FootprintsHistoryWindow || (exports.FootprintsHistoryWindow = FootprintsHistoryWindow = {}));
/** Visibility and initial activation for a map activity filter (mobile map UI). */
var MapFilterState;
(function (MapFilterState) {
  /** Always active; user cannot turn off. */
  MapFilterState["Locked"] = "Locked";
  /** Active on first app open; user can toggle afterward. */
  MapFilterState["Init"] = "Init";
  /** Off until the user enables it. */
  MapFilterState["Default"] = "Default";
  /** Not shown in the map filter UI at all. */
  MapFilterState["Hidden"] = "Hidden";
})(MapFilterState || (exports.MapFilterState = MapFilterState = {}));
var VenueActivityType;
(function (VenueActivityType) {
  VenueActivityType["CheckedIns"] = "checkedIns";
  /** Visit check-ins within the admin-configured recent window (venueAggregateWindows.recentCheckinsWindowDays). */
  VenueActivityType["RecentCheckins"] = "recentCheckins";
  VenueActivityType["Events"] = "events";
  VenueActivityType["VisitPlans"] = "visitPlans";
  VenueActivityType["Breadcrumbs"] = "breadcrumbs";
  VenueActivityType["Views"] = "views";
  VenueActivityType["Stickers"] = "stickers";
})(VenueActivityType || (exports.VenueActivityType = VenueActivityType = {}));
/** Stable key for a row in VenueDto.aggregates (peek / venue detail UI). */
var VenueAggregateType;
(function (VenueAggregateType) {
  VenueAggregateType["CheckedInUsers"] = "checkedInUsers";
  VenueAggregateType["MatchingUsers"] = "matchingUsers";
  VenueAggregateType["EventRsvps"] = "eventRsvps";
  VenueAggregateType["VisitPlans"] = "visitPlans";
  VenueAggregateType["RecentViews"] = "recentViews";
  VenueAggregateType["Breadcrumbs"] = "breadcrumbs";
  VenueAggregateType["Stickers"] = "stickers";
})(VenueAggregateType || (exports.VenueAggregateType = VenueAggregateType = {}));
var AuditLogEventType;
(function (AuditLogEventType) {
  AuditLogEventType["UnlockUser"] = "unlockUser";
  AuditLogEventType["ClearLoginFailedAttempts"] = "clearLoginFailedAttempts";
  AuditLogEventType["LockUser"] = "lockUser";
  AuditLogEventType["SetVibeEmoji"] = "setVibeEmoji";
  AuditLogEventType["FlagBreadcrumb"] = "flagBreadcrumb";
  AuditLogEventType["UnflagBreadcrumb"] = "unflagBreadcrumb";
  AuditLogEventType["DeleteBreadcrumb"] = "deleteBreadcrumb";
  AuditLogEventType["FlagBreadcrumbReply"] = "flagBreadcrumbReply";
  AuditLogEventType["UnflagBreadcrumbReply"] = "unflagBreadcrumbReply";
  AuditLogEventType["DeleteBreadcrumbReply"] = "deleteBreadcrumbReply";
  AuditLogEventType["FlagSticker"] = "flagSticker";
  AuditLogEventType["UnflagSticker"] = "unflagSticker";
  AuditLogEventType["DeleteSticker"] = "deleteSticker";
  AuditLogEventType["FlagMessage"] = "flagMessage";
  AuditLogEventType["UnflagMessage"] = "unflagMessage";
  AuditLogEventType["DeleteMessage"] = "deleteMessage";
  AuditLogEventType["WarnUser"] = "warnUser";
  AuditLogEventType["CreateDevTelephoneNumber"] = "createDevTelephoneNumber";
  AuditLogEventType["UpdateDevTelephoneNumber"] = "updateDevTelephoneNumber";
  AuditLogEventType["DeleteDevTelephoneNumber"] = "deleteDevTelephoneNumber";
  AuditLogEventType["CreateIntention"] = "createIntention";
  AuditLogEventType["UpdateIntention"] = "updateIntention";
  AuditLogEventType["DeleteIntention"] = "deleteIntention";
  AuditLogEventType["SetUserIntention"] = "setUserIntention";
  AuditLogEventType["ClearUserIntention"] = "clearUserIntention";
  AuditLogEventType["ReorderIntentions"] = "reorderIntentions";
  AuditLogEventType["ManuallyVerifyPhoto"] = "manuallyVerifyPhoto";
  AuditLogEventType["RemoveUserPhoto"] = "removeUserPhoto";
  AuditLogEventType["PinSticker"] = "pinSticker";
  AuditLogEventType["UnpinSticker"] = "unpinSticker";
  AuditLogEventType["CreateSimulatedPerson"] = "createSimulatedPerson";
  AuditLogEventType["UpdateSimulatedPerson"] = "updateSimulatedPerson";
  AuditLogEventType["DeleteSimulatedPerson"] = "deleteSimulatedPerson";
})(AuditLogEventType || (exports.AuditLogEventType = AuditLogEventType = {}));
var ModerationContentType;
(function (ModerationContentType) {
  ModerationContentType["VenueBreadcrumb"] = "VenueBreadcrumb";
  ModerationContentType["VenueBreadcrumbReply"] = "VenueBreadcrumbReply";
  ModerationContentType["Message"] = "Message";
  ModerationContentType["Sticker"] = "Sticker";
})(ModerationContentType || (exports.ModerationContentType = ModerationContentType = {}));
var AdminUserBreadcrumbActivityType;
(function (AdminUserBreadcrumbActivityType) {
  AdminUserBreadcrumbActivityType["Breadcrumb"] = "Breadcrumb";
  AdminUserBreadcrumbActivityType["Reply"] = "Reply";
})(AdminUserBreadcrumbActivityType || (exports.AdminUserBreadcrumbActivityType = AdminUserBreadcrumbActivityType = {}));
var AuditLogProducer;
(function (AuditLogProducer) {
  AuditLogProducer["Client"] = "client";
  AuditLogProducer["System"] = "system";
})(AuditLogProducer || (exports.AuditLogProducer = AuditLogProducer = {}));
/** Outcome of a single push-notification send attempt, recorded in NotificationLog. */
var NotificationLogStatus;
(function (NotificationLogStatus) {
  NotificationLogStatus["Success"] = "Success";
  NotificationLogStatus["Failure"] = "Failure";
  NotificationLogStatus["Skipped"] = "Skipped";
})(NotificationLogStatus || (exports.NotificationLogStatus = NotificationLogStatus = {}));
/** Delivery channel used for a NotificationLog entry. */
var NotificationLogChannel;
(function (NotificationLogChannel) {
  NotificationLogChannel["Visible"] = "Visible";
  NotificationLogChannel["Silent"] = "Silent";
  NotificationLogChannel["Badge"] = "Badge";
})(NotificationLogChannel || (exports.NotificationLogChannel = NotificationLogChannel = {}));
/** What triggered a NotificationLog entry. */
var NotificationLogSource;
(function (NotificationLogSource) {
  NotificationLogSource["Scheduled"] = "scheduled";
  NotificationLogSource["Event"] = "event";
  NotificationLogSource["Venue"] = "venue";
  NotificationLogSource["Batch"] = "batch";
  NotificationLogSource["Test"] = "test";
  NotificationLogSource["Badge"] = "badge";
  NotificationLogSource["MyPlaces"] = "myplaces";
  NotificationLogSource["Blast"] = "blast";
  /** Admin push to the RSVPs of one event (event id in the log's metadata). */
  NotificationLogSource["EventRsvpBlast"] = "event_rsvp_blast";
})(NotificationLogSource || (exports.NotificationLogSource = NotificationLogSource = {}));
/** Outcome of a read-only scheduled-trigger eligibility check for one user + trigger. */
var NotificationTriggerDiagnosisResult;
(function (NotificationTriggerDiagnosisResult) {
  /** All eligibility checks pass — the live scheduled job would send this right now. */
  NotificationTriggerDiagnosisResult["WouldSend"] = "WouldSend";
  /** At least one eligibility check failed; see `reasons`. */
  NotificationTriggerDiagnosisResult["Ineligible"] = "Ineligible";
  /** The trigger has no enabled NotificationPreset, so it never fires regardless of user state. */
  NotificationTriggerDiagnosisResult["NoPresetEnabled"] = "NoPresetEnabled";
})(NotificationTriggerDiagnosisResult || (exports.NotificationTriggerDiagnosisResult = NotificationTriggerDiagnosisResult = {}));
/** Planned visit window for a personal venue visit plan (not a community event RSVP). */
/**
 * How an auto check-in generated visit plan was resolved for its day. `CheckedIn` is final (the
 * geofence/location check checked the user in, or the cron found them there); `Away` (the
 * slot's location check found them over VENUE_AUTO_CHECK_IN_AWAY_DISTANCE_METERS away, so no
 * reminder) and `Reminded` (reminder push sent) can still turn into `CheckedIn` if they show up.
 */
var VenueAutoCheckInOutcome;
(function (VenueAutoCheckInOutcome) {
  VenueAutoCheckInOutcome["CheckedIn"] = "checkedIn";
  VenueAutoCheckInOutcome["Reminded"] = "reminded";
  VenueAutoCheckInOutcome["Away"] = "away";
})(VenueAutoCheckInOutcome || (exports.VenueAutoCheckInOutcome = VenueAutoCheckInOutcome = {}));
/**
 * `extraData.autoCheckInAction` on the silent `BackgroundedAppPing` pushes the auto check-in
 * timeline sends (reusing that type so the existing native silent-push plumbing delivers them):
 * `Arm` wakes the app shortly before a slot to re-arm its geofences, `LocationCheck` asks it for
 * its location early in a slot that hasn't seen a check-in yet.
 */
var VenueAutoCheckInPushAction;
(function (VenueAutoCheckInPushAction) {
  VenueAutoCheckInPushAction["Arm"] = "arm";
  VenueAutoCheckInPushAction["LocationCheck"] = "locationCheck";
})(VenueAutoCheckInPushAction || (exports.VenueAutoCheckInPushAction = VenueAutoCheckInPushAction = {}));
var VenueVisitPlanTimeSlot;
(function (VenueVisitPlanTimeSlot) {
  VenueVisitPlanTimeSlot["Morning"] = "morning";
  VenueVisitPlanTimeSlot["Midday"] = "midday";
  VenueVisitPlanTimeSlot["Afternoon"] = "afternoon";
  VenueVisitPlanTimeSlot["Evening"] = "evening";
  VenueVisitPlanTimeSlot["LateNight"] = "lateNight";
  /** No fixed window — never counts as "passed" while its planned date is still relevant. */
  VenueVisitPlanTimeSlot["NotSure"] = "notSure";
  /** Spans the full calendar day; see `isVenueVisitPlanTimeSlotSelectable` for its
   *  own cutoff rule — it stops being a valid *new* choice once any of the concrete
   *  slots above has passed, even though its window nominally runs to midnight. */
  VenueVisitPlanTimeSlot["AllDay"] = "allDay";
})(VenueVisitPlanTimeSlot || (exports.VenueVisitPlanTimeSlot = VenueVisitPlanTimeSlot = {}));
/** Granular admin panel access rights — one value per protected module. */
var AdminPermission;
(function (AdminPermission) {
  AdminPermission["Dashboard"] = "Dashboard";
  AdminPermission["Users"] = "Users";
  AdminPermission["CheckedInUsers"] = "CheckedInUsers";
  AdminPermission["Venues"] = "Venues";
  AdminPermission["Breadcrumbs"] = "Breadcrumbs";
  AdminPermission["Stickers"] = "Stickers";
  AdminPermission["Visits"] = "Visits";
  AdminPermission["Likes"] = "Likes";
  AdminPermission["Blocks"] = "Blocks";
  AdminPermission["Conversations"] = "Conversations";
  AdminPermission["Customers"] = "Customers";
  AdminPermission["Admin"] = "Admin";
  AdminPermission["AuthenticatedAccounts"] = "AuthenticatedAccounts";
  AdminPermission["AppLaunches"] = "AppLaunches";
  AdminPermission["AuditLogs"] = "AuditLogs";
  AdminPermission["FeatureFlags"] = "FeatureFlags";
  AdminPermission["DevTelephoneNumber"] = "DevTelephoneNumber";
  AdminPermission["Reports"] = "Reports";
  AdminPermission["Jobs"] = "Jobs";
  AdminPermission["Notifications"] = "Notifications";
  AdminPermission["Comments"] = "Comments";
  AdminPermission["Map"] = "Map";
  AdminPermission["Intentions"] = "Intentions";
  AdminPermission["Events"] = "Events";
  AdminPermission["SystemStatus"] = "SystemStatus";
  AdminPermission["PhotoVerification"] = "PhotoVerification";
  AdminPermission["Simulation"] = "Simulation";
  AdminPermission["Tickets"] = "Tickets";
})(AdminPermission || (exports.AdminPermission = AdminPermission = {}));
/** Whether a Vision photo check ran during registration or an existing-profile update. */
var PhotoVerificationContext;
(function (PhotoVerificationContext) {
  PhotoVerificationContext["Registration"] = "Registration";
  PhotoVerificationContext["Profile"] = "Profile";
})(PhotoVerificationContext || (exports.PhotoVerificationContext = PhotoVerificationContext = {}));
/**
 * Ticket payment state. Mirrors Square's Payment.status (APPROVED, PENDING, COMPLETED,
 * CANCELED, FAILED) plus refund states derived from Payment.refunded_money.
 */
var TicketStatus;
(function (TicketStatus) {
  /** Payment submitted, outcome not known yet (Square PENDING, or our call to Square didn't return). */
  TicketStatus["Pending"] = "PENDING";
  /** Card authorized but not captured yet (Square APPROVED). */
  TicketStatus["Approved"] = "APPROVED";
  /** Charged — the ticket is valid. */
  TicketStatus["Completed"] = "COMPLETED";
  /** Authorization voided before capture (Square CANCELED). */
  TicketStatus["Canceled"] = "CANCELED";
  /** Declined or errored (Square FAILED, or Square rejected the create-payment call). */
  TicketStatus["Failed"] = "FAILED";
  /** Part of the total was refunded; the ticket stays valid. */
  TicketStatus["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
  /** The whole total was refunded; the ticket is no longer valid. */
  TicketStatus["Refunded"] = "REFUNDED";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
/** Statuses that hold the user's spot for an event (block a second purchase, valid at the door unless Pending). */
exports.ACTIVE_TICKET_STATUSES = [TicketStatus.Pending, TicketStatus.Approved, TicketStatus.Completed, TicketStatus.PartiallyRefunded];
/**
 * Lifecycle of a user's refund request for a ticket. The money side mirrors Square's
 * Refund.status (PENDING → PROCESSING, COMPLETED → REFUNDED, REJECTED/FAILED → FAILED).
 */
var RefundRequestStatus;
(function (RefundRequestStatus) {
  /** Waiting for an admin decision. */
  RefundRequestStatus["Pending"] = "PENDING";
  /** Approved; Square is processing the refund (or its outcome isn't confirmed yet). */
  RefundRequestStatus["Processing"] = "PROCESSING";
  /** Square completed the refund. */
  RefundRequestStatus["Refunded"] = "REFUNDED";
  /** Declined by an admin. */
  RefundRequestStatus["Rejected"] = "REJECTED";
  /** Approved, but Square refused or failed the refund — an admin can retry. */
  RefundRequestStatus["Failed"] = "FAILED";
})(RefundRequestStatus || (exports.RefundRequestStatus = RefundRequestStatus = {}));
/** A ticket can have only one request in these states at a time. */
exports.ACTIVE_REFUND_REQUEST_STATUSES = [RefundRequestStatus.Pending, RefundRequestStatus.Processing];
/** What a user report (and its admin review) points at. */
var ContentReportTargetType;
(function (ContentReportTargetType) {
  ContentReportTargetType["Note"] = "note";
  ContentReportTargetType["Moment"] = "moment";
})(ContentReportTargetType || (exports.ContentReportTargetType = ContentReportTargetType = {}));
var ContentReportStatus;
(function (ContentReportStatus) {
  ContentReportStatus["Open"] = "open";
  /** Admin unflagged the item: it stays up. */
  ContentReportStatus["Dismissed"] = "dismissed";
  /** Admin deleted the item. */
  ContentReportStatus["Removed"] = "removed";
})(ContentReportStatus || (exports.ContentReportStatus = ContentReportStatus = {}));
//# sourceMappingURL=enums.js.map